import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { LocalNumbersLayout } from 'pages/settings/pages/compliance/pages/localNumbers/layout/LocalNumbersLayout'
import { LocalNumbersPage } from 'pages/settings/pages/compliance/pages/localNumbers/ui/localNumbersPage'

export const LocalNumbersRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<LocalNumbersLayout />}>
        <Route path={'/'} element={<LocalNumbersPage />} />
      </Route>
    </RoutesWithNotFound>
  )
}
